<template>
  <el-dialog
    title="自定义任务包标签管理"
    :visible="visible"
    width="680px"
    append-to-body
    :close-on-click-modal="false"
    @open="onOpen"
    @close="onClose">
    <div class="flag-dialog">
      <div class="flag-dialog__section-title">
        <span>已有自定义标签</span>
        <span class="flag-dialog__count">共 {{ tags.length }} 个标签</span>
      </div>
      <div class="flag-dialog__tag-box" v-loading="loading">
        <div v-if="tags.length" class="flag-dialog__tag-grid">
          <el-tag
            v-for="tag in tags"
            :key="tag.id"
            class="flag-dialog__tag"
            closable
            :disable-transitions="true"
            @close="onDeleteTag(tag)">
            {{ tag.name }}
          </el-tag>
        </div>
        <div v-else class="flag-dialog__empty">暂无自定义标签</div>
      </div>

      <div class="flag-dialog__section-title flag-dialog__section-title--create">
        <span>新增标签</span>
        <span class="flag-dialog__tip">标签名称最多支持5个字符</span>
      </div>
      <div class="flag-dialog__create-row">
        <el-input
          v-model="newTagName"
          maxlength="5"
          placeholder="新标签名"
          :disabled="creating || tags.length >= maxCount"
          @keyup.enter.native="onCreateTag" />
        <el-button
          type="primary"
          icon="el-icon-plus"
          :loading="creating"
          :disabled="!canSubmit"
          @click="onCreateTag">添加
        </el-button>
      </div>
      <div class="flag-dialog__create-meta">
        <span>{{ tipText }}</span>
        <span>{{ tagNameLength }}/5</span>
      </div>
      <el-alert
        class="flag-dialog__notice"
        title="注意事项"
        type="warning"
        :closable="false"
        description="删除标签后，已绑定该标签的任务包会自动解除关联。标签名称不可重复，最多可创建20个自定义标签。" />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ProjectTaskPackageFlagDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      tags: [],
      newTagName: '',
      loading: false,
      creating: false,
      deletingId: null,
      maxCount: 20,
    }
  },
  computed: {
    tagNameLength () {
      return Array.from(String(this.newTagName || '').trim()).length
    },
    tipText () {
      if (this.tags.length >= this.maxCount) {
        return '最多可创建20个自定义标签'
      }
      if (this.tagNameLength > 5) {
        return '标签名称最多支持5个字符'
      }
      return '按回车键可快速添加'
    },
    canSubmit () {
      const name = String(this.newTagName || '').trim()
      if (!name || this.creating || this.tags.length >= this.maxCount) {
        return false
      }
      if (Array.from(name).length > 5) {
        return false
      }
      return !this.tags.some(t => t.name === name)
    },
  },
  methods: {
    onOpen () {
      this.loadTags()
    },
    onClose () {
      this.newTagName = ''
      this.$emit('update:visible', false)
      this.$emit('changed')
    },
    loadTags () {
      this.loading = true
      return request.alert('queryProjectTaskPackageFlag', {}).then(({data}) => {
        const payload = (data && data.data) ? data.data : data
        this.tags = (payload && payload.custom) || []
        if (payload && payload.max_custom) {
          this.maxCount = payload.max_custom
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onCreateTag () {
      if (!this.canSubmit) {
        return
      }
      this.creating = true
      return request.alert('createProjectTaskPackageFlag', {name: this.newTagName.trim()}).then(() => {
        this.$message.success('添加成功')
        this.newTagName = ''
        this.$emit('changed')
        return this.loadTags()
      }).finally(() => {
        this.creating = false
      })
    },
    onDeleteTag (tag) {
      if (this.deletingId) {
        return
      }
      this.$confirm(`删除标签“${tag.name}”后，已绑定该标签的任务包将自动解绑，是否继续？`, '提示', {
        type: 'warning',
      }).then(() => {
        this.deletingId = tag.id
        return request.alert('deleteProjectTaskPackageFlag', {id: tag.id}).then(() => {
          this.$message.success('删除成功')
          this.$emit('changed')
          return this.loadTags()
        }).finally(() => {
          this.deletingId = null
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.flag-dialog {
  color: #606266;
}
.flag-dialog__section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-weight: bold;
  color: #303133;
}
.flag-dialog__section-title--create {
  margin-top: 24px;
}
.flag-dialog__count,
.flag-dialog__tip,
.flag-dialog__create-meta {
  font-size: 12px;
  font-weight: normal;
  color: #909399;
}
.flag-dialog__tag-box {
  min-height: 86px;
  padding: 14px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
.flag-dialog__tag-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 10px;
}
.flag-dialog__tag {
  width: 100%;
  text-align: center;
}
.flag-dialog__empty {
  line-height: 58px;
  text-align: center;
  color: #909399;
}
.flag-dialog__create-row {
  display: grid;
  grid-template-columns: 1fr 112px;
  grid-gap: 12px;
}
.flag-dialog__create-meta {
  display: flex;
  justify-content: space-between;
  min-height: 20px;
  margin-top: 8px;
}
.flag-dialog__notice {
  margin-top: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/project-task-package/components/ProjectTaskPackageFlagDialog.vue